import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useQueryClient } from "@tanstack/react-query"

import { socket } from "./socket"

// Listens for the `cv-processed` socket event emitted by the backend when KGE
// finishes analyzing a CV, and invalidates the React Query cache so the list
// refetches immediately. Mirrors useProcessedJobsWebSocket, but invalidates the
// query (rather than calling the fetcher with default params) so the refetch
// respects whatever limit/offset/language the caller originally configured.
export const useProcessedCVsWebSocket = (connectionCondition = false) => {
  const queryClient = useQueryClient()
  const auth = useSelector((state) => state.auth)

  useEffect(() => {
    const webSocket = socket(auth?.token)

    if (connectionCondition) {
      webSocket.connect()

      webSocket.on("cv-processed", () => {
        queryClient.invalidateQueries({ queryKey: ["cvs"] })
      })

      webSocket.on("message", (text) => console.log(text))
    } else {
      webSocket.disconnect()
    }

    return () => {
      webSocket.disconnect()
    }
  }, [auth?.token, connectionCondition, queryClient])
}
